<template>
  <div class="controls-wrapper">
    <icon-button icon="el-icon-close" v-if="leftControl" @click.stop.prevent="removeGroup" />
    <template v-else>
      <icon-button icon="users" fa @click.stop.prevent="showMembersDialog = true" />
      <icon-button icon="el-icon-edit" @click.stop.prevent="showEditDialog = true" />
    </template>

    <el-dialog
      v-if="!leftControl && showEditDialog"
      :append-to-body="true"
      append-to-body
      width="400px"
      title="Edit group"
      :visible.sync="showEditDialog">
      <upsert-form
        v-if="showEditDialog"
        :organization="organization"
        :group="group"
        @updated="onUpdated"
        editing />
    </el-dialog>

    <el-dialog
      v-if="!leftControl && showMembersDialog"
      :append-to-body="true"
      append-to-body
      width="400px"
      :title="`Members of ${group.name}`"
      :visible.sync="showMembersDialog">
      <member-manager
        v-if="showMembersDialog"
        :organization="organization"
        :group="group"
        @refresh="$emit('refresh')" />
    </el-dialog>
  </div>
</template>

<script>
import UpsertForm from './UpsertForm'
import MemberManager from './MemberManager'

export default {
  name: 'GroupControls',
  components: { UpsertForm, MemberManager },
  props: {
    organization: {
      type: Object,
      required: true
    },
    group: {
      type: Object,
      required: true
    },
    leftControl: {
      type: Boolean,
      required: false
    }
  },
  data () {
    return {
      showEditDialog: false,
      showMembersDialog: false
    }
  },
  methods: {
    onUpdated () {
      this.showEditDialog = false
      this.$emit('refresh')
    },
    removeGroup () {
      this.$confirm(
        `Delete group '${this.group.name}'? Any prices scoped to this group will also be removed.`,
        'Are you sure?',
        {
          confirmButtonText: 'Delete',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }
      ).then(async () => {
        try {
          await this.$http.delete(
            this.$api.organization(this.$route.params.orgId).group(this.group.id).remove
          )
          this.$message.success('Group deleted')
          this.$emit('refresh')
        } catch (e) {
          this.$message.error('Could not delete group')
        }
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
  .controls-wrapper {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/organizations/organization/lists/Groups/GroupControls.vue